export const environment = {
  production: true,
  apiUrl: 'API_SERVICO_PRINCIPAL'
};
